export enum TreatmentDemoVideoStatus {
    none = 0,
    pendingAssign = 1,
    pendingUpload = 2,
    uploaded = 3,
    skipped = 4,
}
